////////////////////////////////////////////////////////////////////////////////
// Agent
////////////////////////////////////////////////////////////////////////////////

 /**
  * Query User Agent data rendered directly into your HTML markup.
  *
  * @author Mark Notton <mark@marknotton.uk>
  *
  * @link https://github.com/marknotton/craft-plugin-agent
  *
  * @license Copyright 2019 Mark Notton
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */

class Agent {

  constructor (element) {

    let $this = this;

    window.device = [];

    this.element    = element || document.getElementsByTagName("html")[0];
    this.attributes = this.element.attributes;

    // List of known notched devices and their screen resolutions.
    let notchedScreens = {
      'iphoneX'    : [1125, 2436],
      'iphoneXr'   : [828, 1792],
      'iphoneXMax' : [1242, 2688]
    };

    // Run the autoloader methods
    ['browser', 'platform', 'mobile', 'tablet', 'desktop', 'touch', 'viewport'].forEach(function (method) {
      window[method] = $this[method];
    })

    // Add a listener for mobile and tablets to check for orientation changes. Call this function on Dom Ready too.
    if (window.mobile || window.tablet) {
      window.addEventListener('orientationchange', (event) => {
        setTimeout(this.orientation.update, 10);
      });
      this.orientation.update
    }

    // Apply a boolean for the touch screen detection
    window.device.touch = this.touch;

    // Add device width in pixels and device height in pixels to the screen object
    if ( window.screen !== undefined ) {
      for (var attr in this.screen) {
        window.screen[attr] = this.screen[attr];
      }
    } else {
      window.screen = this.screen;
    }

    // Loop through known notched devices
    for (const key of Object.keys(notchedScreens)) {
      if (screen.pixelWidth == notchedScreens[key][0] && screen.pixelHeight == notchedScreens[key][1]
        || screen.pixelWidth == notchedScreens[key][1] && screen.pixelHeight == notchedScreens[key][0]) {
        window.device.type = key;
        window.device.notched = true
        this.notch;
      }
    }

  }

  get browser () {
    if (this.attributes['data-browser']) {
      let values = this.attributes.getNamedItem('data-browser').value.split(' ');
      return {
        name: values[0] || null,
        version: values[1] || null
      }
    }
  }

  get platform () {
    if (this.attributes['data-platform']) {
      let value = this.attributes.getNamedItem('data-platform').value;
      return value || 'unknown';
    }
  }

  get mobile () {
    if (this.attributes['data-device']) {
      let values = this.attributes.getNamedItem('data-device').value;
      return values == 'mobile';
    }
  }

  get tablet () {
    if (this.attributes['data-device']) {
      let values = this.attributes.getNamedItem('data-device').value;
      return values == 'tablet'
    }
  }

  get desktop () {
    if (this.attributes['data-device']) {
      let values = this.attributes.getNamedItem('data-device').value;
      return values == 'desktop'
    }
  }

  get touch () {
    return 'ontouchstart' in window || window.navigator.msPointerEnabled || 'ontouchstart' in document.documentElement;
  }

  get viewport () {
    return window.viewport = {
      width : window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      height : window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    };
  }

  get screen () {
    var ratio = window.devicePixelRatio || 1
    return {
      pixelWidth:screen.width * ratio,
      pixelHeight:screen.height * ratio
    }
  }

  get notch () {

    if (window.device.orientation == 'landscape') {
      // If the device is rotated left 90 degrees, assume the notch exists on the left
      this.element.setAttribute("data-notch", 'left')
      window.device.notch = 'left'
    } else if (window.device.orientation == 'upside-down landscape') {
      // If the device is rotated right 90 degrees, assume the notch exists on the right
      this.element.setAttribute("data-notch", 'right')
      window.device.notch = 'right'
    } else {
      // If the device is not landscape at all, remove both classes
      // this.element.removeAttribute("data-notch")
      // window.device.notch = false;
      this.element.setAttribute("data-notch", 'top')
      window.device.notch = 'top'
    }
    return window.device.notch;
  }

  get orientation () {

    let $this = this;

    return {

      get update () {

        // Update the global device.orientation variable
        window.device.orientation = $this.orientation.check;

        // Update the data-orientation on the HTML element
        $this.element.setAttribute("data-orientation", window.device.orientation)

        // If the device is notched do a check for 'the notch' and it's position
        if (window.device.notched) {
          $this.notch
        }
      },
      get check () {
        var orientation = ''

        if ('orientation' in window) {
        // Mobile
          switch (window.orientation) {
            case 0:
              orientation = 'portrait'
              break
            case 90:
              orientation = 'landscape'
              break
            case 180:
              orientation = 'upside-down portrait'
              break
            case -90:
              orientation = 'upside-down landscape'
              break
          }
        } else if ('orientation' in window.screen) {
        // Webkit
          if (screen.orientation.type === 'landscape-primary') {
            orientation = 'landscape'
          } else if (screen.orientation.type === 'landscape-secondary') {
            orientation = 'upside-down landscape'
          } else if (screen.orientation.type === 'portrait-primary') {
            orientation = 'portrait'
          } else if (screen.orientation.type === 'portrait-secondary') {
            orientation = 'upside-down portrait'
          }
        } else if ('mozOrientation' in window.screen) {
        // Firefox
          if (screen.mozOrientation === 'landscape-primary') {
            orientation = 'landscape'
          } else if (screen.mozOrientation === 'landscape-secondary') {
            orientation = 'upside-down landscape'
          } else if (screen.mozOrientation === 'portrait-primary') {
            orientation = 'portrait'
          } else if (screen.mozOrientation === 'portrait-secondary') {
            orientation = 'upside-down portrait'
          }
        } else if ('matchMedia' in window) {
          var portMediaQuery = window.matchMedia('all and (orientation:portrait)'),
            landMediaQuery = window.matchMedia('all and (orientation:landscape)')

          if (landMediaQuery.matches) {
            orientation = 'landscape'
          } else if (portMediaQuery.matches) {
            orientation = 'portrait'
          }
        } else {
          if (screen.width > screen.height) {
            orientation = 'landscape'
          } else if (screen.width <= screen.height) {
            orientation = 'portrait'
          } else {
            return false
          }
        }

        return orientation
      }
    }
  }
}
